import { useMemo, type ReactElement, type ReactNode } from 'react'
import { isDefined } from '@terros/common'
import { Box, Stack } from '@mantine/core'
import { useTeamHierarchyContext } from '../TeamHierarchyContext'
import { ViewTeamPanel } from '../../viewTeam'
import { TeamConnectionsLayer } from './TeamConnectionsLayer'
import { LevelRow } from './LevelRow'
import { AddTeamLevel } from './AddLevel'

export const TeamHierarchyDisplay = ({ footer }: { footer?: ReactNode }): ReactElement => {
  const { teamLevels } = useTeamHierarchyContext()

  return (
    <Box className='flex min-h-0 flex-1 overflow-hidden'>
      <Box className='min-w-0 flex-1 overflow-auto'>
        <Stack gap='sm' px='xl' className='py-4xl min-w-max'>
          <Box className='gap-6xl relative flex flex-col'>
            <TeamConnectionsLayer />
            <Box className='gap-6xl flex flex-col'>
              <AddTeamLevel level='high' />
              {Array.from(teamLevels.entries()).map(([level, teams]) => (
                <LevelRow key={level} level={level} teams={teams} />
              ))}
              <AddTeamLevel level='low' />
            </Box>
          </Box>
          {footer}
        </Stack>
      </Box>
      <TeamPanel />
    </Box>
  )
}

const TeamPanel = (): ReactElement => {
  const { viewTeam, setViewTeam, teams: allTeams, company } = useTeamHierarchyContext()
  const viewingTeam = useMemo(() => allTeams.find((t) => t.teamId === viewTeam), [allTeams, viewTeam])

  return (
    <ViewTeamPanel
      company={company}
      opened={isDefined(viewTeam)}
      team={viewingTeam}
      onNavigateTeam={setViewTeam}
      onClose={() => setViewTeam(null)}
    />
  )
}
